import { Guides } from "./components/guides.js";
import { OldBrowserChecker } from "./components/oldBrowserChecker.js";
import { Hero } from "./components/hero.js";
import { Parallax } from "./components/parallax.js";
import { LanguageMenu } from "./components/languageMenu.js";
import { MobileMenu } from "./components/mobileMenu.js";
import { Headroom } from "./components/headroom.js";
import { CallToAction } from "./components/callToAction.js";
import { TeaserCards } from "./components/teaserCards.js";
import { Accordion } from "./components/accordion.js";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

/* -------------------------------------------------- */
/* 🙂 General */
/* -------------------------------------------------- */

const isReducedMotion = window.matchMedia(
	"(prefers-reduced-motion: reduce)"
).matches;

/* -------------------------------------------------- */
/* 👵 Check for old browsers */
/* -------------------------------------------------- */

new OldBrowserChecker();

/* -------------------------------------------------- */
/* 📏 Guides */
/* -------------------------------------------------- */

new Guides({
	"(min-width: 1001px)": 12,
	"(min-width: 601px)": 8,
	"(min-width: 0px)": 4,
});

/* -------------------------------------------------- */
/* 🌐 Language menu */
/* -------------------------------------------------- */

const languageMenu = new LanguageMenu();

/* -------------------------------------------------- */
/* 🌐 Mobile menu */
/* -------------------------------------------------- */

const mobileMenu = new MobileMenu();

/* -------------------------------------------------- */
/* 🦸‍♂️ Hero */
/* -------------------------------------------------- */

const hero = new Hero();

/* -------------------------------------------------- */
/* 🌌 Parallax */
/* -------------------------------------------------- */

const parallax = new Parallax();

/* -------------------------------------------------- */
/* 📢 Call to action */
/* -------------------------------------------------- */

const callToAction = new CallToAction();

/* -------------------------------------------------- */
/* 🃏 Teaser cards */
/* -------------------------------------------------- */

const teaserCards = new TeaserCards();

/* -------------------------------------------------- */
/* 🪗 Accordion */
/* -------------------------------------------------- */

const accordion = new Accordion();

/* -------------------------------------------------- */
/* 💆‍♂️ Header */
/* -------------------------------------------------- */

const header = document.querySelector(".header");

const headroom = new Headroom(header, {
	offset: 50,
	tolerance: 10,
	classes: {
		initial: "header",
		pinned: "header--pinned",
		unpinned: "header--unpinned",
		top: "header--top",
		notTop: "header--not-top",
		bottom: "header--bottom",
		notBottom: "header--not-bottom",
		frozen: "header--frozen",
	},
	onPin: function () {
		// Close language menu
		languageMenu.close();
		// Close mobile menu
		mobileMenu.close();
	},
	onUnpin: function () {
		// Close language menu
		languageMenu.close();
		// Close mobile menu
		mobileMenu.close();
	},
	onTop: function () {
		// Close language menu
		languageMenu.close();
		// Close mobile menu
		mobileMenu.close();
	},
	onNotTop: function () {
		// Close language menu
		languageMenu.close();
		// Close mobile menu
		mobileMenu.close();
	},
});

headroom.init();

/* -------------------------------------------------- */
/* 🦶 Footer */
/* -------------------------------------------------- */

// const footer = document.querySelector(".footer");

// if (footer && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
// 	const footerJ = footer.querySelector(".footer__j");
// 	const footerSakura = footer.querySelector(".footer__sakura");

// 	gsap.set(footerSakura, {
// 		marginTop: -200,
// 	});

// 	gsap
// 		.timeline({
// 			scrollTrigger: {
// 				trigger: footer,
// 				start: "top bottom",
// 				end: "bottom bottom",
// 				scrub: true,
// 			},
// 			defaults: {
// 				ease: "none",
// 			},
// 		})

// 		.to(
// 			footerSakura,
// 			{
// 				y: 200,
// 			},
// 			0
// 		);
// }

/* -------------------------------------------------- */
/* 🦥 Lazy loading */
/* -------------------------------------------------- */

document.querySelectorAll('[loading="lazy"]').forEach((element) => {
	const animateIn = () => {
		element.style.opacity = 1;
	};

	if (element.complete) {
		animateIn();
	} else {
		element.addEventListener("load", animateIn);
	}
});

/* -------------------------------------------------- */
/* 📥 Forms */
/* -------------------------------------------------- */

let forms = document.querySelectorAll("form[data-action]");
forms.forEach((form) => {
	form.setAttribute("action", form.getAttribute("data-action"));
	form.removeAttribute("data-action");
});
